module.exports = __webpack_public_path__ + "static/media/icon-otros.e85c7683.svg";